import React, { useState } from "react";
import "./Whatsapp.css";
import { FaWhatsapp, FaTimes } from "react-icons/fa";

const Whatsapp = () => {
  const [showDepartments, setShowDepartments] = useState(false);

  const departments = [
    {
      name: "Web Development",
      message:
        "Hi, I'm interested in your website development services. Could you share details about pricing and project timelines?",
      number: "+919155599968",
    },
    {
      name: "Software Solutions",
      message:
        "Hi, I would like to know more about your custom software development services for businesses.",
      number: "+919155599968",
    },
    {
      name: "Corporate IT Services",
      message:
        "Hi, I'm inquiring about your IT services for enterprises, including support and maintenance packages.",
      number: "+919155599968",
    },
    {
      name: "Technical Support",
      message:
        "Hi, I'm facing technical issues with my existing software/website. Can you assist me in resolving them?",
      number: "+919155599968",
    },
    {
      name: "HR Department",
      message:
        "Hi, I would like to inquire about current job openings and career opportunities at your company.",
      number: "+919155599968",
    },
  ];

  const handleWhatsAppClick = (e) => {
    e.preventDefault();
    setShowDepartments(!showDepartments);
  };

  const handleDepartmentClick = (number, message) => {
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/${number}?text=${encodedMessage}`, "_blank");
    setShowDepartments(false);
  };

  return (
    <div className="whatsapp-container">
      {showDepartments && (
        <div className="departments-popup">
          <div className="departments-header">
            <h4>Select Department</h4>
            <button
              onClick={() => setShowDepartments(false)}
              className="close-btn"
            >
              <FaTimes />
            </button>
          </div>
          <div className="departments-list">
            {departments.map((dept, index) => (
              <div
                key={index}
                className="department-item"
                onClick={() => handleDepartmentClick(dept.number, dept.message)}
              >
                {dept.name}
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="sticky-icons-wp">
        <div className="whatsapp-tooltip">
          {showDepartments
            ? "Select a department to chat"
            : "Need help? Message us!"}
        </div>
        <a href="#" onClick={handleWhatsAppClick} className="icon-wp wp">
          <FaWhatsapp />
        </a>
      </div>
    </div>
  );
};

export default Whatsapp;
